// @ts-nocheck
import pincodeQuery from "india-pincode-search";

const toTitleCase = (str) =>
  str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const resolvers = {
  IND: async (pincode) => {
    try {
      const results = pincodeQuery.search(pincode);

      if (results && results.length > 0) {
        const first = results[0];

        return {
          district: toTitleCase(first.district),
          cityTown: toTitleCase(first.office),
          state: toTitleCase(first.state),
        };
      }
    } catch (e) {
      console.warn("Pincode lookup failed:", e);
    }

    return undefined;
  },
};
